import styled from "styled-components";
import media from "../../../../styles/media";

export const ModulesListWrapper = styled.div`
	display: flex;
	flex-direction: column;

	${media.lessThan("medium")`
		position: fixed;
		top: 60px;
		width: 100%;
		z-index: 1204;
		left: 0;
		background: #fff;
		height: calc(100vh - 60px);
		overflow: scroll;
		align-items: center;
		padding-top: 70px;
	`}
`;

export const CloseModulesListButtonWrapper = styled.div`
	background: #fff;
	position: fixed;
	height: 70px;
	top: 60px;
	z-index: 1300;
	width: 100%;
	display: flex;
	justify-content: center;
`;

export const CloseModulesListButton = styled.button`
	width: 40px;
	height: 40px;
	background: ${(props) => props.theme.color.primary};
	border-radius: 100px;
	position: absolute;
	top: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
	cursor: pointer;
	transition: opacity 0.2s ease;

	&:hover {
		opacity: 0.9;
	}

	&:focus {
		outline: 2px solid ${(props) => props.theme.color.primary};
		outline-offset: 2px;
	}
`;

export const ShowModulesListButton = styled.button`
	padding: 10px 0;
	width: 100%;
	background: ${(props) => props.theme.color.primary};
	font-weight: 400;
	color: #fff;
	line-height: 20px;
	font-size: 0.75rem;
	text-transform: uppercase;
	text-align: center;
	display: none;
	margin-top: 20px;
	border: none;
	cursor: pointer;

	${media.lessThan("medium")`
		display: block;
	`}

	&:focus {
		outline: 2px solid #fff;
		outline-offset: -4px;
	}
`;
